module.exports = __webpack_public_path__ + "static/media/sub_white.c3e74970.png";